import styled from "styled-components";
import {
  EmployeeType,
  TaskQuantityDTO,
  TaskType,
} from "../services/task.interface";
import { SetStateAction } from "react";
import { VehicleType } from "../../scooters/service/scooter.interface";
import { Input } from "antd";
import { useAuthContext } from "../../auth/context/useAuthContext";

interface EditableCellProps {
  type: EmployeeType;
  edit: boolean;
  capacity: number;
  results: number;
  targetQuantity: TaskType;
  targetVehicleType: VehicleType;
  quantityCountData: TaskQuantityDTO;
  setQuantityCountData: React.Dispatch<SetStateAction<TaskQuantityDTO>>;
}

//TODO: setState 연결, 합계
export function EditableCell(args: EditableCellProps): JSX.Element {
  const {
    type,
    capacity,
    edit,
    results,
    targetVehicleType,
    targetQuantity,
    quantityCountData,
    setQuantityCountData,
  } = args;
  const { auth, hasPermission } = useAuthContext();

  function parseTaskQuantityValue(value: string, fallbackValue: number): number {
    const parsedValue = value ? parseInt(value, 10) : fallbackValue;
    if (Number.isNaN(parsedValue) || parsedValue < 0) return fallbackValue;
    return Math.max(parsedValue, 0);
  }

  function isEditable(
    editType: "capacity" | "quantity",
    type: EmployeeType,
    hasPermission: (permission: string) => boolean
  ) {
    if (!auth) return false;
    const quantityPermission =
      editType === "quantity"
        ? "TaskResultQuantityEditEnable"
        : "AllottedTaskQuantityEditEnable";
    if (!hasPermission(quantityPermission)) return false;
    if (type === "OS") return hasPermission("OsTaskQuantityEditEnable");
    if (type === "DM") return hasPermission("DmTaskQuantityEditEnable");
    return false;
  }

  if (edit) {
    return (
      <EditingCell>
        <InputWrapper>
          <Input
            disabled={!isEditable("quantity", type, hasPermission)}
            min={0}
            type="number"
            size={"small"}
            value={
              quantityCountData
                ? quantityCountData.results[targetVehicleType]?.[
                    targetQuantity
                  ] ?? results
                : results
            }
            onChange={(e) =>
              setQuantityCountData((prev) => ({
                ...prev,
                results: {
                  ...prev.results,
                  [targetVehicleType]: {
                    ...(prev.results[targetVehicleType] ?? {}),
                    [targetQuantity]: parseTaskQuantityValue(
                      e.target.value,
                      results
                    ),
                  },
                },
              }))
            }
          />
          <OriginalValue>기존 {results}건</OriginalValue>
        </InputWrapper>
        <p>/</p>
        <InputWrapper>
          <Input
            disabled={!isEditable("capacity", type, hasPermission)}
            min={0}
            type="number"
            size={"small"}
            value={
              quantityCountData
                ? quantityCountData.capacity[targetVehicleType]?.[
                    targetQuantity
                  ] ?? capacity
                : capacity
            }
            onChange={(e) =>
              setQuantityCountData((prev) => ({
                ...prev,
                capacity: {
                  ...prev.capacity,
                  [targetVehicleType]: {
                    ...(prev.capacity[targetVehicleType] ?? {}),
                    [targetQuantity]: parseTaskQuantityValue(
                      e.target.value,
                      capacity
                    ),
                  },
                },
              }))
            }
          />
          <OriginalValue>기존 {capacity}건</OriginalValue>
        </InputWrapper>
      </EditingCell>
    );
  }
  return (
    <NormalCell>
      <p>
        {results}건 / <span>{capacity}</span>
      </p>
    </NormalCell>
  );
}

const NormalCell = styled.div`
  text-align: center;
  & > p {
    margin: 0;
    & > span {
      color: #909399;
    }
  }
`;

const EditingCell = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  & > p {
    margin: 4px 8px 0;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  & > input {
    width: 48px;
  }
`;

const OriginalValue = styled.span`
  color: #909399;
  font-size: 11px;
  line-height: 16px;
  white-space: nowrap;
`;
